import { FC } from "react";
import { ReactComponent as ZipIcon } from "@web-src/images/icons/zip-icon.svg";
import { ReactComponent as TextIcon } from "@web-src/images/icons/text-icon.svg";
import { ReactComponent as PdfIcon } from "@web-src/images/icons/pdf-icon.svg";
import { ReactComponent as DocIcon } from "@web-src/images/icons/doc-icon.svg";
import { ReactComponent as AudioIcon } from "@web-src/images/icons/audio-icon.svg";
import { useEntitySelectedProvider } from "@web-src/modules/entities/providers/EntityProvider/useEntitySelectedProvider";
import { UsersAvatarStack } from "@jugl-web/domain-resources/users/components/UsersAvatarStack";
import { ReactComponent as Mp4Icon } from "./icons/mp4.svg";
import { ReactComponent as FolderNormalIcon } from "./icons/folder.svg";
import { ReactComponent as PublicFolder } from "./icons/publicFolder.svg";
import { ReactComponent as PrivateFolder } from "./icons/privateFolder.svg";
import { ReactComponent as ExcelIcon } from "./icons/excel.svg";
import { ReactComponent as OtherFilesIcon } from "./icons/otherFiles.svg";
import { ReactComponent as SysCpanelFolderIcon } from "./icons/sys-cpanel-folder.svg";
import { FilePermissionType } from "../../types";

export const DriveDisplayIcon: FC<{
  icon: string;
  typeFolder?: FilePermissionType | false;
  className?: string;
  params?: {
    isSystem?: boolean;
  };
  usersIds?: string[];
}> = ({ icon, typeFolder, params, className, usersIds }) => {
  const { entityId } = useEntitySelectedProvider();

  switch (icon) {
    case "folder":
      if (params?.isSystem)
        return <SysCpanelFolderIcon className={className} />;
      if (typeFolder === "shared")
        return (
          <div className="relative">
            <FolderNormalIcon className={className} />

            {usersIds && (
              <div className="absolute bottom-0 left-0.5">
                <UsersAvatarStack
                  entityId={entityId}
                  userIds={usersIds}
                  maxCount={2}
                  size="xs"
                />
              </div>
            )}
          </div>
        );
      if (typeFolder === "private")
        return <PrivateFolder className={className} />;
      return <PublicFolder className={className} />;
    case ".txt":
      return <TextIcon className={className} />;
    case ".zip":
    case ".rar":
      return <ZipIcon className={className} />;
    case ".pdf":
      return <PdfIcon className={className} />;
    case ".doc":
    case ".docx":
      return <DocIcon className={className} />;
    case ".xls":
    case ".xlsx":
      return <ExcelIcon className={className} />;
    case ".mp3":
    case ".wav":
    case ".flac":
    case ".mp4a":
      return <AudioIcon className={className} />;
    case ".mp4":
    case ".mov":
    case ".webm":
    case ".avi":
    case ".mkv":
    case ".wmv":
    case ".qt":
      return <Mp4Icon className={className} />;
    default:
      return <OtherFilesIcon className={className} />;
  }
};
